var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.16683V5.8335C4 3.62683 4.66667 1.8335 8 1.8335C11.3333 1.8335 12 3.62683 12 5.8335V7.16683",
    stroke: "url(#paint0_linear_984_12103)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 15.167H4.66671C2.00004 15.167 1.33337 14.5003 1.33337 11.8337V10.5003C1.33337 7.83366 2.00004 7.16699 4.66671 7.16699H11.3334C14 7.16699 14.6667 7.83366 14.6667 10.5003V11.8337C14.6667 14.5003 14 15.167 11.3334 15.167Z",
    stroke: "url(#paint1_linear_984_12103)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6643 11.1668H10.6703",
    stroke: "url(#paint2_linear_984_12103)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99703 11.1668H8.00302",
    stroke: "url(#paint3_linear_984_12103)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32967 11.1668H5.33566",
    stroke: "url(#paint4_linear_984_12103)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_12103",
    x1: 8,
    y1: 1.8335,
    x2: 8,
    y2: 7.16683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_12103",
    x1: 8.00004,
    y1: 7.16699,
    x2: 8.00004,
    y2: 15.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_984_12103",
    x1: 10.6673,
    y1: 10.8335,
    x2: 10.6673,
    y2: 11.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_984_12103",
    x1: 8.00002,
    y1: 10.8335,
    x2: 8.00002,
    y2: 11.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_984_12103",
    x1: 5.33267,
    y1: 10.8335,
    x2: 5.33267,
    y2: 11.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a0d0d30cb3bb48b0caa21a7f75f187c6.svg";
export { ForwardRef as ReactComponent };